import Tooltip from '@components/Tooltips/Tooltip';
import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const CardHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
`;

export const HeaderCol = styled.div`
  :nth-of-type(2) {
    display: flex;
    justify-content: center;
    color: red;
    margin-bottom: 15px;
  }

  :nth-of-type(3) {
    display: flex;
    justify-content: end;
    align-items: start;
  }
`;

export const Exclamation = styled.div`
  background: #d1d1d1;
  width: 28px;
  height: 28px;
  border-radius: 100%;

  svg {
    path {
      fill: #fff;
    }
  }
`;

export const CardContent = styled.div<{ rows?: number }>`
  height: calc(100% - 50px);
  display: grid;
  grid-template-rows: repeat(${(props) => props.rows}, 1fr);
  gap: 8px;
  position: relative;

  ${mq(Devices.laptop)} {
    height: unset;
  }
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 8px;
  position: relative;
`;

export const MapText = styled.div<{ disable?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.disable ? '#959595' : 'unset')};
`;
